<button *ngIf="form && checkComponent()" matTooltip="Modifica Stato Con Motivazione" type="button"
 class="my-bounce btn styleButton mx-2 clsButtonDefault" (click)="openModal()" [disabled]="disabled">
 {{ getLabel("buttonLabel") }}
</button>